import { render, staticRenderFns } from "./ActiveCall.vue?vue&type=template&id=6b721301&scoped=true"
import script from "./ActiveCall.vue?vue&type=script&lang=js"
export * from "./ActiveCall.vue?vue&type=script&lang=js"
import style0 from "./ActiveCall.vue?vue&type=style&index=0&id=6b721301&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b721301",
  null
  
)

export default component.exports